<template>
    <div class="ProductService">
        <div class="product-service-left-info">
            <p class="product-service-title-text">产品与服务</p>
            <p class="product-service-sub-title-text">PRODUCTS AND SERVICES</p>
            <p class="product-service-content-text">
                多品牌产品支持，满足您的各类需求，图你所想，为企业提供完整的解决方案
            </p>
            <div class="learn-more-btn-container">
                <router-link to="/product-services">
                    <el-button class="learn-more-btn" plain
                        >了解更多 ++</el-button
                    >
                </router-link>
            </div>
        </div>
        <div class="product-service-right-info">
            <el-row class="product-service-row">
                    <el-col :span="6" class="one-service-card">
                        <div class="card-img-container">
                            <img src="../../assets/images/16434.png" alt="" />
                        </div>
                        <div class="one-service-text-content">
                            <p class="one-service-card-title">
                                信息安全服务
                            </p>
                            <p class="one-service-card-main-text">
                               提供信安产品、安全咨询、安全培训、安全认证、安全应急、安全运维、等保服务、云安全服务等一揽子解决方案 
                            </p>
                        </div>
                    </el-col>

                    <el-col :span="6" class="one-service-card">
                        <div class="card-img-container">
                            <img src="../../assets/images/17462.png" alt="" />
                        </div>
                        <div class="one-service-text-content">
                            <p class="one-service-card-title">
                                数据中心集成服务
                            </p>
                            <p class="one-service-card-main-text">
                               为用户创造安全、可靠、易用、高效、智能的高性能系统环境和极致业务体验
                            </p>
                        </div>
                    </el-col>

                    <el-col :span="6" class="one-service-card">
                        <div class="card-img-container">
                            <img src="../../assets/images/5956403.png" alt="" />
                        </div>
                        <div class="one-service-text-content">
                            <p class="one-service-card-title">
                                云计算服务
                            </p>
                            <p class="one-service-card-main-text">
                               帮助用户享受业务云化的便利，实现业务创新，从而不断创造跨界全新的业务价值
                            </p>
                        </div>
                    </el-col>

                                        <el-col :span="6" class="one-service-card">
                        <div class="card-img-container">
                            <img src="../../assets/images/75377.png" alt="" />
                        </div>
                        <div class="one-service-text-content">
                            <p class="one-service-card-title">
                                运维服务
                            </p>
                            <p class="one-service-card-main-text">
                               为客户提供基于服务级别协议（SLA）各类网络、信息安全、数据中心等运维服务。
                            </p>
                        </div>
                    </el-col>
               
            </el-row>
        </div>
    </div>
</template>

<script>
import { GETPRODUCTLIST } from "../../utils/uriList";

export default {
    mounted() {
        this.getProductList();
    },
    data() {
        return {
            productList: [],
        };
    },
    methods: {
        async getProductList() {
            const response = await this.$http.get(GETPRODUCTLIST);
            if (response.data.code === 0) {
                this.productList = response.data.data.slice(0, 4);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/components/Home/ProductService.scss";
</style>
